import * as React from "react"
import Svg from "/src/assets/images/common__icn__close.svg"

interface Props {
    width?: number
    height?: number
}

export default function CloseIcon({width, height}:Props){
    return(
        <Svg width={width || 32 } height={height || 32} title=""/>
    )
}